import { date, InferType, object, ObjectSchema, string } from "yup";
import { CancelarMovimentacaoFinanceiraContract } from "../contracts/cancelar-movimentacao-financeira.contract";

export const cancelarMovimentacaoFinanceiraSchema: ObjectSchema<CancelarMovimentacaoFinanceiraContract> = object({

    cancellationDate: date().required("Data de cancelamento é obrigatória"),
    cancellationReason: string().required("Motivo de cancelamento é obrigatório"),
});


export type CancelarMovimentacaoFinanceiraFormData = InferType<typeof cancelarMovimentacaoFinanceiraSchema>;